import { Capacitor } from '@capacitor/core';
import { EnvConfig } from '@core';

export const getNewVersionNative = (env: EnvConfig): void => {
  const platform: string = Capacitor.getPlatform();

  if (platform === 'android' && env.androidApkUrl) {
    window.open(env.androidApkUrl, '_blank');
  }

  if (platform === 'ios' && env.iOSApkUrl) {
    window.open(env.iOSApkUrl, '_blank');
  }
};
